import { Component } from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams, Platform, ViewController} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";


@Component({
  selector: 'page-archive-std-wise-report',
  templateUrl: 'archive-std-wise-report.html',
})
export class ArchiveStdWiseReportPage {

  STDWiseReport:any;
  STDWiseReport1:any;


  constructor(public navCtrl: NavController,
              public service: ServiceProvider,
              public viewCtrl: ViewController,
              public loadingCtrl: LoadingController,
              public platform : Platform,
              public navParams: NavParams) {

    this.platform.ready().then(() => {

      this.loadvalues();
    });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ArchiveStdWiseReportPage');
  }

  loadvalues() {

    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });

    loading.present();

    this.STDWiseReport = [];
    this.STDWiseReport1 = [];

    this.service.httpcall('app_web_service/get_archive_stdwise_report?').subscribe(data => {

      this.STDWiseReport = data;
      this.STDWiseReport1 = data['Total'];
      console.log('STDWiseReport',this.STDWiseReport);
      loading.dismiss();
    })
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);

    this.loadvalues();

    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }

  backBTN() {
    this.viewCtrl.dismiss();
  }


}



// WEBPACK FOOTER //
// ./src/pages/archive-std-wise-report/archive-std-wise-report.ts